module.exports = __webpack_public_path__ + "static/media/social.dca4d7bd.png";